import { call } from '@/lib/api';
import { TContact } from '@/models/contacts';
import { Alert, Box, Button, Group } from '@mantine/core';
import { useEffect, useState } from 'react';
import { PiCheck, PiWarning } from 'react-icons/pi';

type Status = 'invite-pending' | 'invite-accepted' | 'not-invited';

export default function PortalAccess({ contact }: { contact: TContact }) {
  const email = contact.column_values.find(
    ({ column }) => column.title === 'Email',
  )?.text;

  const [status, setStatus] = useState<Status>('not-invited');

  useEffect(() => {
    if (!email) return;
    call<{ status: Status }>('customer/portal-invited', { json: { email } })
      .then((res) => res.json())
      .then(({ status }) => setStatus(status));
  }, [email]);

  if (status === 'not-invited') {
    return (
      <Alert title="No Portal Access" icon={<PiWarning size="3em" />} maw={600}>
        <Box mb="md">
          This contact was not invited thus does not have an access to Customer
          Portal
        </Box>
        <Group justify="flex-end">
          <Button
            maw={150}
            onClick={() => {
              call('customer/portal-invite', {
                json: { pulseId: contact.id },
              }).then(() => setStatus('invite-pending'));
            }}
          >
            Invite to Portal
          </Button>
        </Group>
      </Alert>
    );
  } else if (status === 'invite-pending') {
    return (
      <Alert
        title="Portal Access Pending"
        icon={<PiWarning size="3em" />}
        maw={600}
      >
        <Box mb="md">
          And email with invitation has been sent out to the customer.
        </Box>
        <Group justify="flex-end">
          <Button
            maw={150}
            onClick={() => {
              call('customer/portal-invite', {
                json: { pulseId: contact.id },
              }).then(() => setStatus('invite-pending'));
            }}
          >
            Re-send invite
          </Button>
        </Group>
      </Alert>
    );
  }

  return (
    <Alert
      title="Use has access to the Customer Portal"
      c="green"
      bg="green.1"
      icon={<PiCheck size="3em" />}
      maw={600}
    ></Alert>
  );
}
